import {
  HypeItErrorCodeType,
  mapHypeItErrorCodeType,
  mapTaskType,
  mapTeamType,
  mapUserMeType,
  mapUserType,
  TaskType,
  TeamType,
  useFindAllTaskListItems,
  useFindOwnUserSuspense,
  useFindTaskAssignablePersons,
  useFindTaskAssignableTeams,
  UserMeType,
  UserType,
} from '@api';

type UseTasksDataReturnType = {
  userData: UserMeType;
  tasks: TaskType[] | undefined;
  tasksError: HypeItErrorCodeType | null;
  assignableUsers: UserType[] | undefined;
  assignableTeams: TeamType[] | undefined;
};

export const useTasksData = (): UseTasksDataReturnType => {
  const { data: userData } = useFindOwnUserSuspense({
    query: { select: (data) => mapUserMeType(data.data) },
  });
  const { data: tasks, error: tasksListItemsError } = useFindAllTaskListItems({
    query: {
      select: (response) => response.data.map(mapTaskType),
    },
  });

  const { data: assignableUsers, error: tasksAssignableUsersError } =
    useFindTaskAssignablePersons({
      query: {
        select: (response) => response.data.map(mapUserType),
      },
    });
  const { data: assignableTeams, error: tasksAssignableTeamsError } =
    useFindTaskAssignableTeams({
      query: {
        select: (response) => response.data.map(mapTeamType),
      },
    });

  const error =
    tasksListItemsError ||
    tasksAssignableUsersError ||
    tasksAssignableTeamsError;

  const tasksError = mapHypeItErrorCodeType(error?.response?.data);

  return {
    userData,
    tasks,
    tasksError,
    assignableUsers,
    assignableTeams,
  };
};
